import { TCard } from '../../../types/cardColumnLayout.types';
import { ImageField, StringField, LinkField, VideoSitecoreField, TIconField } from '../../../../../types/types';

export class CardModel {
  private readonly card?: TCard;

  constructor(props: TCard) {
    this.card = props || undefined;
  }
  get iconField(): TIconField {
    return this.card?.icon as TIconField;
  }

  get iconName(): string {
    return this.card?.icon?.fields?.iconKey?.value || '';
  }

  get title(): StringField | undefined {
    return this.card?.cardHeading;
  }

  get subheading(): StringField | undefined {
    return this.card?.cardSubheading;
  }

  get image(): ImageField | undefined {
    return this.card?.image;
  }

  get mobileImage(): ImageField | undefined {
    return this.card?.mobileImage;
  }

  get cta1(): LinkField | undefined {
    return this.card?.cardCtaButton;
  }

  get cta2(): LinkField | undefined {
    return this.card?.cardCtaTextLink;
  }
  get video(): VideoSitecoreField | undefined {
    return this.card?.video;
  }

  get useVideo(): boolean {
    return this.card?.useVideo?.value || false;
  }

  get items(): any {
    return this.card?.items;
  }

  get showPopupWithSplitModule(): boolean {
    return (
      (!this.cta1 || (!this.cta1?.value?.url && !this.cta1?.value?.href)) &&
      !!this.card?.items?.[0].fields?.items?.[0] &&
      !!this.splitModuleLabel
    );
  }

  get splitModules(): any {
    return this.card?.items?.[0]?.fields?.items;
  }

  get splitModuleLabel(): string | undefined {
    return this.card?.items?.[0]?.fields?.popUpLabel?.value;
  }
}
